export default __webpack_public_path__ + "static/media/pexels-pixabay-33278.14b76611.jpg";